module.exports = __webpack_public_path__ + "img/customer-a-063.e14be5af.png";